import { fetchJson } from '@atlassian/jira-fetch';
import { getAVPWorkspaceId } from '../../common/utils';

export const fetchAVPDashboard = (dashboardId = '') => {
	const workspace = getAVPWorkspaceId();
	return fetchJson(
		`/gateway/api/avp/workspaceId/${workspace}/api/organizations/${workspace}/dashboards/${dashboardId}`,
	);
};
